import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core'
import { DecimalPipe } from '@angular/common'
import { TranslateService } from '@ngx-translate/core'
import { ContextService } from 'app/services'
import { RadarChart } from 'app/widget/radar-chart-widget/RadarChart'
import { Colors } from 'app/common/config/constants'

@Component({
  standalone: false,
  selector: 'app-radar-chart-widget',
  templateUrl: './radar-chart-widget.component.html',
  styleUrls: ['./radar-chart-widget.component.scss'],
})
export class RadarChartWidgetComponent implements OnInit, OnChanges {
  @Input() title: ''
  @Input() unit = ''
  @Input() data = []
  @Input() isMultiple = false
  @Input() labels = []
  @Input() stats
  @ViewChild('chart', { static: true }) chartElem: ElementRef
  @ViewChild('tooltip', { static: true }) tooltipElem: ElementRef

  get referenceData() {
    return !this.isMultiple ? [this.data || []] : this.data
  }

  get comparisonData() {
    return this.isMultiple ? this.data[1] || [] : null
  }

  get isVisitsAvailable() {
    return this.context.isVisitsAvailable()
  }

  constructor(
    private decimalPipe: DecimalPipe,
    private translateService: TranslateService,
    private context: ContextService,
  ) {}

  ngOnInit() {
    this.ngOnChanges(null)
  }

  ngOnChanges(changes) {
    if (this.data && this.data.length) {
      if (changes === null) {
        this.drawChart()
        return null
      }
      for (const key of Object.keys(changes)) {
        if (changes[key].currentValue) {
          if (
            JSON.stringify(changes[key].previousValue) !==
            JSON.stringify(changes[key].currentValue)
          ) {
            this.drawChart()
            return null
          }
        }
      }
    }
  }

  private drawChart() {
    this.removeContent()
    const width = this.chartElem.nativeElement.offsetWidth || 228
    const height = width
    const mycfg = {
      w: width - 48,
      h: height,
      levels: 6,
      margin: { top: 20, right: 20, bottom: 20, left: 20 }, // The margins of the SVG
      maxValue: 0, // What is the value that the biggest circle will represent
      labelFactor: 1.1, // How much farther than the radius of the outer circle should the labels be placed
      wrapWidth: 60, // The number of pixels after which a label needs to be given a new line
      opacityArea: 0.35, // The opacity of the area of the blob
      dotRadius: 4, // The size of the colored circles of each blog
      opacityCircles: 0.1, // The opacity of the circles of each blob
      strokeWidth: 1, // The width of the stroke around each blob
      roundStrokes: false, // If true the area and stroke will follow a round path (cardinal-closed)
      font: {
        family: 'Vodafone',
        size: '14px',
        weight: 'bold',
      },
      background: {
        color: Colors.colorN05,
        borderColor: Colors.colorN10,
        opacity: 1,
      },
      lines: {
        nbrLevels: 3,
        color: 3,
      },
      area: {
        opacity: 0.1,
        color: [Colors.colorAccent, Colors.colorSecondary],
        dot: {
          radius: 4,
          color: [Colors.colorAccent, Colors.colorSecondary],
          opacity: 0.8,
        },
      },
      popup: {
        element: this.tooltipElem.nativeElement,
        template: (data) => this.generatePopup(data),
      },
    }
    RadarChart.draw(this.chartElem.nativeElement, this.referenceData, mycfg)
  }

  generatePopup(data) {
    const value = this.decimalPipe.transform(data.value, '1.0-0')
    return `
    <div class="tooltip-content">
      <p>
        <span class="name">${this.translateService.instant('Direction')}</span>
        <span class="category">${this.translateService.instant(
          data.category,
        )}</span>
      </p>
      <p>
        <span class="value">${this.translateService.instant(value)}%</span>
        <small class="unit">${this.translateService.instant(
          'of visitors',
        )}</small>
      </p>
    </div>
    `
  }

  private removeContent() {
    const node = this.chartElem.nativeElement
    while (node.firstChild) {
      node.removeChild(node.firstChild)
    }
  }
}
